import { sendCheck, statusCheck } from "./table"

const exportCsv = (tableName: string) => {
  if (!tableName) return
  const attrName = `[data-tname="${tableName}"]`
  const tableElm = document?.querySelector(attrName)
  if (!tableElm) return

  const data = Array.from(tableElm?.querySelectorAll('thead > tr > th'))
  const headNames = data
    // @ts-ignore
    .filter((item) => item.innerText !== 'Action' && item.innerText !== '' && item.innerText.length > 0)
    .map((item) => {
      // @ts-ignore
      let headerText = item.innerText
      if (headerText.includes(',')) {
        headerText = `"${headerText.replace(/"/g, '""')}"`
      }

      return headerText
    })

  const rows = Array.from(tableElm?.querySelectorAll('tbody > tr'))
  const bodyData = rows.map((row) => {
    const rowData = Array.from(row.querySelectorAll('td'))
    return rowData
      .filter((item) => item.innerText !== 'Detail' && item.innerText !== '')
      .map((item) => {
        let cellText = item.innerText
        if (cellText.includes(',') || cellText.includes('\n')) {
          cellText = `"${cellText.replace(/"/g, '""')}"`
        }

        return cellText
      })
  })

  const csvData = [headNames, ...bodyData]
  const csvContent = csvData.map((row) => row.join(',')).join('\n')

  const fileName = `${tableName}`
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const csvURL = window.URL.createObjectURL(blob)
  const tempLink = document.createElement('a')
  tempLink.href = csvURL
  tempLink.setAttribute('download', `${fileName}.csv`)
  tempLink.click()
}

export const exportAllCsv = (tableName: string, rows: any[], columns?: any[]) => {
  const headKeys: string[] = []
  const headNames: string[] = []

  if (columns) {
    columns.forEach((item: any) => {
      headKeys.push(item.dataIndex)
      headNames.push(item.title)
    })
  }

  const csvContent = createCSV(headNames, rows, columns);

  const fileName = `${tableName}`
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const csvURL = window.URL.createObjectURL(blob)
  const tempLink = document.createElement('a')
  tempLink.href = csvURL
  tempLink.setAttribute('download', `${fileName}-ALL.csv`)
  tempLink.click()
}

function createCSV(headNames: any[], rows: any[], columns: any[] | undefined) {
  // Başlık satırını oluştur
  let csvContent = headNames.join(",") + "\r\n";

  // Her satır için verileri ekleyin
  rows.forEach(row => {
    let rowContent = columns?.map((column: { dataIndex: string, status?: boolean, send?: boolean, render?: any }) => {
      if (column?.status) {
        return statusCheck(row[column.dataIndex]).text;
      } else if (column.send) {
        return sendCheck(row[column.dataIndex]).text;
      } else if (column.render) {
        return column.render(row[column.dataIndex], row)
      } else {
        return row[column.dataIndex];
      }
    }).join(",");
    csvContent += rowContent + "\r\n";
  });

  return csvContent;
}

export default exportCsv
